import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import uniqueId from 'lodash/uniqueId';
import _isEmpty from 'lodash/isEmpty';
import { formStyleConstants } from '../../utils/constants/form-style-constants';
import { isEmpty } from '../../utils/obj-utils';
import FieldHeader from './FieldHeader';
import { formMessageConstants } from '../../utils/constants/form-message-constants';

class FormMobilePhoneInput extends Component {
    constructor(props) {
        super(props);
        const { validState } = this.props;

        this.handleBlur = this.handleBlur.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleFieldIsFilled = this.handleFieldIsFilled.bind(this);
        this.handleFlagContainerClick = this.handleFlagContainerClick.bind(this);
        this.handleFlagsListContainer = this.handleFlagsListContainer.bind(this);
        this.handleListItemEnter = this.handleListItemEnter.bind(this);
        this.handleListItemLeave = this.handleListItemLeave.bind(this);
        this.handleCountryItemClick = this.handleCountryItemClick.bind(this);
        this.getProcessedDefaultValue = this.getProcessedDefaultValue.bind(this);
        this.getRetrievedDefaultValue = this.getRetrievedDefaultValue.bind(this);

        this.box = React.createRef();
        this.flagsListContainer = React.createRef();

        const processedDefaultValue = this.getProcessedDefaultValue();

        this.initialState = {
            ...processedDefaultValue,
            isValid: true,
            errorMessage: formMessageConstants.emptyString
        };

        if (validState) {
            this.initialState.isValid = validState.isValid;
            this.initialState.errorMessage = validState.errorMessage;
        }

        this.state = this.initialState;
    }
    componentDidMount() {
        document.addEventListener('click', this.handleOutsideClick);
    }

    componentWillReceiveProps(nextProps) {
        let defaultValue = this.props.defaultValue;

        if (_isEmpty(defaultValue)) {
            defaultValue = {};
        }

        if (_isEmpty(nextProps.defaultValue) || defaultValue.phoneNumber === nextProps.defaultValue.phoneNumber) {
            return;
        }

        if (!_isEmpty(nextProps.defaultValue)) {
            const retrievedDefaultValue = this.getRetrievedDefaultValue(nextProps.defaultValue);

            this.setState((state) => ({
                ...state,
                ...retrievedDefaultValue
            }));

            return;
        }

        const processedDefaultValue = this.getProcessedDefaultValue();

        this.setState((state) => ({
            ...state,
            processedDefaultValue
        }));
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleOutsideClick);
    }

    getRetrievedDefaultValue(selectedValue) {
        const { phoneNumber, selectedCountry } = selectedValue;

        return { defaultValue: phoneNumber, selectedCountry, isFilled: true };
    }

    getProcessedDefaultValue() {
        const { defaultValue, countries } = this.props;

        let phoneNumber = formMessageConstants.emptyString;
        let selectedCountry = countries.find((country) => country.code === 'GB');

        if (!_isEmpty(defaultValue)) {
            phoneNumber = defaultValue.phoneNumber;
            selectedCountry = defaultValue.selectedCountry;
        }

        return { defaultValue: phoneNumber, selectedCountry, isFilled: !isEmpty(defaultValue) };
    }

    handleOutsideClick = (event) => {
        if (this.box && !this.box.current.contains(event.target) & !this.flagsListContainer.current.contains(event.target)) {
            if (!this.flagsListContainer.current.classList.contains('display-flags-list')) {
                return;
            }

            this.flagsListContainer.current.classList.remove('display-flags-list');
        }
    }

    handleChange(event) {
        const { onChange } = this.props;
        const { value } = event.target;
        const { selectedCountry } = this.state;

        onChange({
            selectedCountry: selectedCountry,
            phoneNumber: value
        });

        this.setState(
            (prevState) => ({
                ...prevState,
                defaultValue: value
            })
        );
    }

    handleBlur(event) {
        const { onBlur } = this.props;
        const { selectedCountry } = this.state;
        const { value } = event.target;
        this.handleFieldIsFilled(value);

        if (onBlur) {
            onBlur({
                selectedCountry: selectedCountry,
                phoneNumber: value
            });
        }
    }

    handleFieldIsFilled(value) {
        const isFilled = value !== formMessageConstants.emptyString;
        this.setState((state) => ({ ...state, isFilled }));
    }

    handleFlagContainerClick(event) {
        const { isDisabled } = this.props;

        event.preventDefault();
        event.stopPropagation();

        if (isDisabled) {
            return;
        }

        this.flagsListContainer.current.classList.toggle('display-flags-list');
    }

    handleFlagsListContainer(event) {
        event.preventDefault();
        event.stopPropagation();

        if (!this.flagsListContainer.current.classList.contains('display-flags-list')) {
            return;
        }

        this.flagsListContainer.current.classList.remove('display-flags-list');
    }

    handleListItemEnter(event) {
        event.preventDefault();
        event.stopPropagation();

        event.target.classList.add('country-list-item-highlight');
    }

    handleListItemLeave(event) {
        event.preventDefault();
        event.stopPropagation();

        event.target.classList.remove('country-list-item-highlight');
    }

    handleCountryItemClick(event) {
        event.preventDefault();
        event.stopPropagation();

        if (_isEmpty(event) ||
            _isEmpty(event.currentTarget) ||
            _isEmpty(event.currentTarget.children)) {
            return;
        }

        const targetChildren = event.currentTarget.children;
        const selectedCountryItem = targetChildren[1];
        const selectedCountryPhonePrefix = targetChildren[2];

        if (_isEmpty(selectedCountryItem) ||
            _isEmpty(selectedCountryPhonePrefix)) {
            return;
        }

        const { onChange } = this.props;
        const { defaultValue } = this.state;
        const { countries } = this.props;

        const selectedCountryItemValue = selectedCountryItem.innerText.trim();
        const selectedCountryPhonePrefixValue = selectedCountryPhonePrefix.innerText.trim();

        const selectedCountry = countries.find((country) => country.label === selectedCountryItemValue &&
            country.phonePrefix === selectedCountryPhonePrefixValue);
        this.flagsListContainer.current.classList.remove('display-flags-list');

        this.setState(
            (prevState) => ({
                ...prevState,
                selectedCountry
            })
        );

        onChange({
            selectedCountry,
            phoneNumber: defaultValue
        });
    }

    render() {
        const {
            name,
            label,
            isHidden,
            headerTitle,
            headerText,
            countries,
            isDisabled,
            validState,
            formRef
        } = this.props;

        const { isValid, errorMessage } = validState || this.state;
        const { defaultValue, isFilled, selectedCountry } = this.state;
        const fieldClassName = name || formStyleConstants.customFieldClassName;

        return (
            <Fragment>
                <FieldHeader
                    fieldName={name}
                    headerTitle={headerTitle}
                    headerText={headerText}
                    textClassName={'text-info'}>
                </FieldHeader>
                <div className='intl-tel-input allow-dropdown'>
                    {selectedCountry &&
                        <div className='flag-container'
                            ref={this.box}
                            onClick={this.handleFlagContainerClick}>
                            <div className={`selected-flag ${isFilled ? formStyleConstants.isFilled : formMessageConstants.emptyString} ${!isValid ? `selected-flag-${formStyleConstants.isInvalid}` : formMessageConstants.emptyString}`} tabIndex='0'>
                                <img className='selected-flag-img iti-flag gb' src={selectedCountry.flag.src} />
                            </div>
                        </div>}

                    <div
                        ref={formRef}
                        className={`form-field auto-mt-xs ${fieldClassName.toLowerCase()}-field ${isFilled ? formStyleConstants.isFilled : formMessageConstants.emptyString} ${!isValid ? formStyleConstants.isInvalid : formMessageConstants.emptyString}`}
                        data-dc-component='form-field'
                        data-form-control
                        style={{ display: isHidden ? 'none' : 'block' }}
                    >
                        <input
                            className='form-field__input form-field-with-flag'
                            type='text'
                            id={name}
                            name={name}
                            disabled={isDisabled}
                            onChange={this.handleChange}
                            onBlur={this.handleBlur}
                            value={defaultValue}
                        />
                        <label className='form-field__label form-label-with-flag' htmlFor={name}>
                            {label}
                        </label>
                        {!isValid ? <ul className='form-field__error-list filled'>
                            <li className='form-field__error-item'>{errorMessage}</li>
                        </ul> : null}
                    </div>
                </div>
                <div ref={this.flagsListContainer}
                    onClick={this.handleFlagsListContainer}
                    className='intl-tel-input iti-container flags-list-container'>
                    <ul className='country-list'>
                        {countries.map((country) => {
                            return <li key={uniqueId()}
                                className='country-list-item'
                                onMouseEnter={this.handleListItemEnter}
                                onMouseLeave={this.handleListItemLeave}
                                onBlur={this.handleListItemLeave}
                                onClick={this.handleCountryItemClick}>
                                <div className='flag-box'>
                                    {country.flag && <img className='flag-to-select-img iti-flag gb' src={country.flag.src} />}
                                </div>
                                <span className='country-name country-to-select'> {country.label}</span>
                                <span className='dial-code'>{country.phonePrefix}</span>
                            </li>;
                        })}
                    </ul>
                </div>
            </Fragment >
        );
    }
}

FormMobilePhoneInput.propTypes = {
    formRef: PropTypes.object,
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    headerTitle: PropTypes.string,
    headerText: PropTypes.string,
    defaultValue: PropTypes.object,
    countries: PropTypes.array,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func,
    validState: PropTypes.object
};

export default FormMobilePhoneInput;
